module.exports = __webpack_public_path__ + "img/report-phone-tower.svg";